<template>
  <div id="app" class="min-h-screen flex flex-col bg-gray-50">
    <TheNavigation />
    <main class="flex-grow pt-16">
      <router-view />
    </main>
    <TheFooter />
  </div>
</template>

<script setup lang="ts">
import TheNavigation from './components/layout/TheNavigation.vue';
import TheFooter from './components/layout/TheFooter.vue';
</script>
